import { ProjectType } from '@lopo-tech/lopo-api'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { ProjectsMyListPage } from 'src/pages/projects_my_list'

const InfrastructureProjectsMyListPage: React.FC<RouteComponentProps> = (props) => (
  <ProjectsMyListPage {...props} projectType={ProjectType.InfrastructureProject} />
)

export default InfrastructureProjectsMyListPage
